import React, {Component} from 'react';
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import queryString from 'querystring'
import AppContainerAuth from './AppContainerAuth'
import LoginPage from '../login/Login.component'
import compose from '../utils/compose'
import {getToken} from '../utils/token'
import withNofeshService  from './withNofeshService.hoc';
import '../App.css';
import '../css/all.css';



class AppContainer extends Component {

  
  saveToken = (userToken) => {
    sessionStorage.setItem('token', JSON.stringify(userToken));    
  };
  saveSToken = (userToken) => {
    sessionStorage.setItem('stoken', JSON.stringify(userToken));    
  };

  componentDidMount()
  {
  }




  refresh = () => {
    const token = getToken(); 
    console.log('AppContainer refresh token', token);
    this.forceUpdate();
  }

  refreshLogout = () => {
    const token = getToken(); 
    console.log('AppContainer refresh token', token);
    this.forceUpdate();
    
  }

  render() {     
    const { nofeshService } = this.props;
    let isAdmin = false;
    const parsed = queryString.parse(this.props.location.search,'?');

    if (parsed) {
      if ( parsed != undefined) {
        //if (parsed.admintoken) {
        if (parsed.t) {
          isAdmin = true;
        }
      }
    }


    let token = getToken();    
    /*
    if(isAdmin) {
      nofeshService.adminGetEmployeeCardNumByToken(parsed.t).then(res  => {

            let  resultObj = res.data;
            if (resultObj > 0) {
              const token_from_srv =  { token: resultObj };
              this.saveToken(token_from_srv); 
              this.saveSToken(token_from_srv); 
            }
      });
    }
    */
    
    if (window.NOFESH_SERVICE_LIVE == undefined) {
      return <LoginPage />;
    }
 

    return token ? <AppContainerAuth  onLoggedOutRefresh={this.refreshLogout}  /> :
      <React.Fragment>
          <LoginPage   onLoggedInRefresh={this.refresh}   />
          <Redirect to="/" ></Redirect>
      </React.Fragment>;
  }
}



export default compose(
    withNofeshService(),
  )( withRouter(AppContainer));


